// extracted by mini-css-extract-plugin
export default {"box":"Zoom_box__m9ZjS","client":"Zoom_client__ieG8p","content":"Zoom_content__FBH9w"};